import { Mark } from '@/util/markdown';
import { Journey } from './journey';

export abstract class PathSegment {
   public readonly type: string;
   public readonly alias: string;
   public chosen = false;
   public readonly children: Array<PathSegment> = [];
   public readonly price: number;
   public readonly showPrice: boolean = false;
   public readonly isCostExternal: boolean = false;
   public readonly title: string;
   public readonly dataObject?: Journey;

   protected constructor(
      type: string,
      title: string,
      alias: string,
      price: number,
      showPrice?: boolean,
      isCostExternal?: boolean,
      children?: Array<PathSegment>,
      dataObject?: Journey) {
      this.type = type;
      this.title = Mark.Down.render(title);
      this.alias = alias;
      this.price = price;

      if (showPrice) {
         this.showPrice = showPrice;
      }
      if (isCostExternal) {
         this.isCostExternal = isCostExternal;
      }
      if (children) {
         this.children = children;
      }
      if (dataObject) {
         this.dataObject = dataObject;
      }
   }
}
